import { useState, useEffect, useMemo } from 'react'
import { ValidateOnType } from 'foundations-library/types'

type ReturnedValueType = [string[], (v: string) => void]

const findValidationErrors = (rls, val) => {
    const errs = []

    if (rls && rls.length) {
        for (const rule of rls) {
            const res = rule(val)
            if (res !== true) {
                errs.push(res)
            }
        }
    }

    return errs
}

/**
 *
 */
export const useValidation = (
    value: any,
    rules: ((v?: any) => string | boolean)[] = [],
    isValid?: (v) => any,
    validateOn: ValidateOnType = 'change',
    valueHasBeenChanged?: boolean,
    inputState?: 'focus' | 'blur' | 'unknown'
): ReturnedValueType => {
    const [errors, setErrors] = useState([])

    const shouldValidate = useMemo(() => {
        return rules && rules.length && (
            validateOn === 'load' ||
            (validateOn === 'change' && valueHasBeenChanged) ||
            (validateOn === 'blur' && inputState === 'blur') ||
            (validateOn === 'focus' && inputState === 'focus')
        )
    }, [validateOn, valueHasBeenChanged, inputState])

    useEffect(() => {
        const errs = findValidationErrors(rules, value)
        if (isValid) isValid(!errs.length)
    }, [])

    useEffect(() => {
        if (shouldValidate) {
            const errs = findValidationErrors(rules, value)
            setErrors([...errs])
        }
    }, [value, rules, shouldValidate])

    useEffect(() => {
        shouldValidate && isValid && isValid(!errors.length)
    }, [shouldValidate, errors.length])

    return [errors, setErrors]
}

export default useValidation
